var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2075_271)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 13.64C19.2 13.96 20.7 14.9733 20.7 16.68V16.88C20.7 17.9733 20.22 18.8333 19.26 19.46C18.3 20.0733 16.92 20.4333 15.12 20.54V22.2H13.22V20.54C11.3933 20.4333 10 20.0667 9.04 19.44C8.08 18.8133 7.6 17.94 7.6 16.82V16.64H9.56V16.82C9.56 18.14 11.1733 18.8 14.4 18.8C17.28 18.8 18.72 18.2333 18.72 17.1V16.9C18.72 16.58 18.6333 16.3267 18.46 16.14C18.2867 15.9533 17.9933 15.8067 17.58 15.7C17.1667 15.58 16.5733 15.48 15.8 15.4L12.38 15.06C10.8333 14.9133 9.7 14.5933 8.98 14.1C8.27333 13.5933 7.92 12.8867 7.92 11.98V11.78C7.92 10.7667 8.38 9.96667 9.3 9.38C10.2333 8.78 11.54 8.43333 13.22 8.34V6.66H15.12V8.36C16.84 8.46667 18.1533 8.82667 19.06 9.44C19.9667 10.04 20.42 10.8667 20.42 11.92V12.08H18.46V11.92C18.46 11.3333 18.0667 10.88 17.28 10.56C16.5067 10.24 15.3933 10.08 13.94 10.08C12.6333 10.08 11.6267 10.2133 10.92 10.48C10.2267 10.7333 9.88 11.1067 9.88 11.6V11.8C9.88 12.0933 9.96667 12.3333 10.14 12.52C10.3267 12.7067 10.6267 12.86 11.04 12.98C11.4667 13.1 12.06 13.2 12.82 13.28L16.2 13.64Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2075_271",
    x1: 2.05435,
    y1: 25.7143,
    x2: 27.8995,
    y2: 23.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9188FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F54FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/_dollar.705f8a6ca6482f12bd88002be3aba095.svg";
export { ForwardRef as ReactComponent };